import { IsNotEmpty, IsString, IsUUID } from 'class-validator';

export interface TrainingConditionImagesMediaUploadUrlDto {
  fileName: string;
  contentType: string;
}

export interface TrainingConditionImagesMediaUploadUrlResultDto {
  url: string;
  fileId: string;
  fileName: string;
}

/**
 * DTO used for uploading an image to the blob storage for a specific
 * file id. This file id corresponds to the name of the blob in object storage.
 */
export class TrainingConditionImagesMediaUploadExistingUrlDto {
  @IsUUID()
  fileId: string;

  @IsString()
  @IsNotEmpty()
  contentType: string;
}

/**
 * Result DTO for the download URL of a blob in object storage.
 */
export interface TrainingConditionImagesMediaUploadExistingUrlResultDto {
  fileId: string;
  url: string;
}

export interface TrainingConditionImagesMediaDeleteBlobResultDto {
  success: boolean;
}
